import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../../environments/environment';

export const apiPrestadoresInterceptor: HttpInterceptorFn = (request, next) => {
  const baseUrl = environment.apiPrestadoresBaseUrl.replace(/\/$/, '');
  const subscriptionKey = environment.ocpApiPrestadores.trim();

  if (!baseUrl || !subscriptionKey || !request.url.startsWith(baseUrl)) return next(request);

  return next(request.clone({
    setHeaders: {
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
  }));
};
